/*let header_on_top = true;
if (window.location.pathname == '/'){
    window.addEventListener("scroll", function(){
        if(window.scrollY < 30){
            if (document.getElementsByClassName('cdc-header__push--top').length == 0){
                document.querySelectorAll('.header-item .site-nav').forEach(function callback(element, index) {
                    if (element.classList.contains('cdc-header__push--top') == false && index != 1){
                        element.classList.add('cdc-header__push--top')                    
                    }    
                });    
            }
        } else {
            if (document.getElementsByClassName('cdc-header__push--top').length > 0){
                document.querySelectorAll('.header-item .site-nav').forEach(element => {
                    element.classList.remove('cdc-header__push--top')                    
                });    
            }
        }
    })            
}*/

if (document.readyState !== 'loading' && document.readyState !== 'interactive') {
    theme.headerNav.init();
} else {
    document.onreadystatechange = () => {
        theme.headerNav.init();
    };
}